const middleware = {}

middleware['nav'] = require('../middleware/nav.js')
middleware['nav'] = middleware['nav'].default || middleware['nav']

middleware['trailing-slash'] = require('../middleware/trailing-slash.js')
middleware['trailing-slash'] = middleware['trailing-slash'].default || middleware['trailing-slash']

export default middleware
